import { w } from './global';

export enum EVENT_CATEGORY {
  CONSENT_BANNER = 'ConsentBanner',
}

export enum EVENT_ACTION {
  CONSENT_BANNER_REQUESTED = 'ConsentBannerRequested',
  CONSENT_BANNER_LOADED = 'ConsentBannerLoaded',
  CONSENT_GRANTED = 'ConsentGranted',
  CONSENT_DENIED = 'ConsentDenied',
  SOURCEPOINT_LIB_ERROR = 'SourcepointLibError',
}
export enum EVENT_LABEL {
  LAYER_ONE = 'layer=1',
  LAYER_TWO = 'layer=2',
  SCOPE_ALL = 'scope=all',
  SCOPE_PARTIAL = 'scope=partial',
}

export enum CHOICE_TYPE {
  ACCEPT_ALL = 11,
  SETTINGS = 12,
  REJECT_ALL = 1,
}

export enum PURPOSE_CONSENT {
  NONE = 'none',
  SOME = 'some',
  ALL = 'all',
}

export enum VENDOR_CONSENT {
  NONE = 'none',
  SOME = 'some',
  ALL = 'all',
}

export const decorateEventObject = (action: string, labels: Array<string> = []): TAnalyticsEvent => {
  return {
    eventAction: action,
    eventLabel: labels.join(';'),
  };
};

export function logAnalyticsEvent(eventAction: string, eventLabels: string[]) {
  const event = decorateEventObject(eventAction, eventLabels);
  const { ecGa, ecGaEventsOnLoad = [] } = w;
  if (ecGa) {
    ecGa('trackEvent', event);
  } else {
    ecGaEventsOnLoad.push(event);
  }
}

export const logConsentBannerLoaded = (labels: string[]) => {
  logAnalyticsEvent(EVENT_ACTION.CONSENT_BANNER_LOADED, labels);
};

export const logConsentGranted = (labels: string[]) => {
  logAnalyticsEvent(EVENT_ACTION.CONSENT_GRANTED, labels);
};

export const logConsentDenied = (labels: string[]) => {
  logAnalyticsEvent(EVENT_ACTION.CONSENT_DENIED, labels);
};

export const logSourcepointLibError = (labels: string[]) => {
  logAnalyticsEvent(EVENT_ACTION.SOURCEPOINT_LIB_ERROR, labels);
};
